import { Link } from '@on3/ui-lib/components/Link';
import { Pen } from '@on3/ui-lib/components/Svg';
import { useAuth } from '@on3/ui-lib/index';
import clsx from 'clsx';
import useAthlete from 'contexts/AthleteProvider';
import { useState } from 'react';

import { GradedSkillsMock } from './GradedSkills';
import styles from './ScoutingMock.module.scss';
import { ScoutingReportMock } from './ScoutingReport';

interface ScoutingMockProps {
  className?: string;
}
export const ScoutingMock = ({ className }: ScoutingMockProps) => {
  const [toggle, setToggle] = useState(false);
  const { athlete } = useAthlete();
  const { isVerifiedPlayer, isDeveloper } = useAuth();
  const allowEdit = isVerifiedPlayer(athlete.key) || isDeveloper();

  return (
    <div className={clsx(styles.block, className)} data-toggle={toggle}>
      <div className={styles.tabs}>
        <button data-type="skills" onClick={() => setToggle(true)}>
          Graded Skills
        </button>
        <button data-type="report" onClick={() => setToggle(false)}>
          Scouting Report
        </button>
      </div>
      <ScoutingReportMock className={styles.report} />
      <GradedSkillsMock className={styles.skills} />
      <Link className={styles.edit} href={`/db/${athlete.slug}/claim-profile/`}>
        <Pen />
        Request On3 Scouting Report
      </Link>
    </div>
  );
};
